/* eslint-disable react/display-name */
import CellData from 'modules/_shared/components/Tables/CellData';
import SocietyGuestsAccessBadge from 'modules/society/components/SocietyGuests/components/SocietyGuestsAccessBadge';

function tableColumns(i18n) {
  return [
    {
      name: i18n.t('Society'),
      field: 'societyName',
      selector: (row) => row[i18n.t('Society')],
      sortable: true,
      grow: 2,
      cell: (row) =>
        CellData.Society({
          society: row.society,
          url: '/detalle-representante',
          type: 'light',
          showHolding: false,
          customLink: row.link || '',
          noRedirect: row.noRedirect,
        }),
      export: true,
    },
    {
      name: i18n.t('AccessLevel'),
      field: 'guest',
      selector: (row) => row[i18n.t('AccessLevel')],
      sortable: true,
      grow: 1,
      cell: (row) => (
        <SocietyGuestsAccessBadge
          guest={row[i18n.t('AccessLevel')]}
          society={row.society}
        />
      ),
      export: true,
    },
  ];
}
export default tableColumns;
